"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _xlsxDownloader = _interopRequireDefault(require("@cimpress-technology/xlsx-downloader"));

var _xlsxLoader = _interopRequireDefault(require("@cimpress-technology/xlsx-loader"));

var _reactComponents = require("@cimpress/react-components");

var _downloadjs = _interopRequireDefault(require("downloadjs"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var actions = _interopRequireWildcard(require("../editorActions"));

var shapes = _interopRequireWildcard(require("../shapes"));

var utils = _interopRequireWildcard(require("../utils"));

var _ToolbarButton = _interopRequireDefault(require("./ToolbarButton"));

var _ToolbarSection = _interopRequireDefault(require("./ToolbarSection"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: stretch;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  height: 43px;\n  padding: 1px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  padding: 0 2px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var containerStyle = (0, _emotion.css)(_templateObject(), colors.platinum);
var innerStyle = (0, _emotion.css)(_templateObject2(), colors.white);

var Toolbar =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Toolbar, _PureComponent);

  function Toolbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Toolbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Toolbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showLoadModal: false,
      showSaveModal: false,
      showAddColumnsModal: false,
      selectedColumnsToAdd: undefined,
      addColumnsIndex: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowAddAbove", function () {
      var _this$props = _this.props,
          columns = _this$props.columns,
          dispatch = _this$props.dispatch,
          selection = _this$props.selection;
      var row = utils.makeEmptyRow(columns);
      var rowIndex = selection ? selection.top : 0;
      dispatch(actions.insertRows(rowIndex, [row]));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowAddBelow", function () {
      var _this$props2 = _this.props,
          columns = _this$props2.columns,
          dispatch = _this$props2.dispatch,
          selection = _this$props2.selection;
      var row = utils.makeEmptyRow(columns);
      var rowIndex = selection ? selection.bottom : 0;
      dispatch(actions.insertRows(rowIndex, [row]));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowRemove", function () {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          selection = _this$props3.selection;

      if (selection) {
        var startIndex = selection.top;
        var endIndex = selection.bottom;
        dispatch(actions.removeRows(startIndex, endIndex));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onColumnAddLeft", function () {
      var selection = _this.props.selection;
      var startIndex = selection ? selection.left : 0;

      _this.setState({
        addColumnsIndex: startIndex,
        showAddColumnsModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onColumnAddRight", function () {
      var selection = _this.props.selection;
      var startIndex = selection ? selection.right : 0;

      _this.setState({
        addColumnsIndex: startIndex,
        showAddColumnsModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onColumnRemove", function () {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          selection = _this$props4.selection;

      if (selection) {
        var startIndex = selection.left;
        var endIndex = selection.right;
        dispatch(actions.removeColumns(startIndex, endIndex));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoadModalCancel", function () {
      _this.setState({
        showLoadModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoadModalOpen", function () {
      _this.setState({
        showLoadModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoadModalSubmit", function (columns, rows, file) {
      var dispatch = _this.props.dispatch;
      dispatch(actions.loadDatasheet(columns, rows, file));

      _this.setState({
        showLoadModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveModalCancel", function () {
      _this.setState({
        showSaveModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveModalOpen", function () {
      _this.setState({
        showSaveModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveModalSubmit", function (file, fileName) {
      _this.setState({
        showSaveModal: false
      });

      (0, _downloadjs.default)(file, fileName);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAvailableColumns", (0, _memoizeOne.default)(function (columns, requiredColumns, optionalColumns) {
      return [].concat((0, _toConsumableArray2.default)(requiredColumns), (0, _toConsumableArray2.default)(optionalColumns)).filter(function (columnName) {
        return !columns.includes(columnName);
      }).sort().map(function (columnName) {
        return {
          label: columnName,
          value: columnName
        };
      });
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelAddColumnsModal", function () {
      _this.setState({
        showAddColumnsModal: false,
        selectedColumnsToAdd: undefined,
        addColumnsIndex: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectedColumnsChanged", function (selectedOptions) {
      _this.setState({
        selectedColumnsToAdd: selectedOptions.map(function (selectedOption) {
          return selectedOption.value;
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAddColumns", function () {
      var dispatch = _this.props.dispatch;
      var _this$state = _this.state,
          selectedColumnsToAdd = _this$state.selectedColumnsToAdd,
          addColumnsIndex = _this$state.addColumnsIndex;

      if (selectedColumnsToAdd && addColumnsIndex >= 0) {
        dispatch(actions.insertColumns(addColumnsIndex, selectedColumnsToAdd));

        _this.setState({
          showAddColumnsModal: false,
          selectedColumnsToAdd: undefined,
          addColumnsIndex: undefined
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Toolbar, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          additionalColumns = _this$props5.additionalColumns,
          columns = _this$props5.columns,
          name = _this$props5.name,
          optionalColumns = _this$props5.optionalColumns,
          requiredColumns = _this$props5.requiredColumns,
          rows = _this$props5.rows,
          readOnly = _this$props5.readOnly,
          allowColumnAddRemove = _this$props5.allowColumnAddRemove;
      var _this$state2 = this.state,
          showLoadModal = _this$state2.showLoadModal,
          showSaveModal = _this$state2.showSaveModal,
          selectedColumnsToAdd = _this$state2.selectedColumnsToAdd;
      var availableColumns = this.getAvailableColumns(columns, requiredColumns, optionalColumns);

      var footer = _react.default.createElement(_reactComponents.Button, {
        type: "default",
        onClick: this.onAddColumns,
        disabled: !selectedColumnsToAdd || selectedColumnsToAdd.length === 0
      }, "Add");

      return _react.default.createElement("div", {
        className: containerStyle
      }, _react.default.createElement(_xlsxDownloader.default, {
        columns: columns,
        initialFileName: name,
        rows: rows,
        show: showSaveModal,
        onCancel: this.onSaveModalCancel,
        onSubmit: this.onSaveModalSubmit
      }), _react.default.createElement(_xlsxLoader.default, {
        additionalColumns: additionalColumns,
        optionalColumns: optionalColumns,
        requiredColumns: requiredColumns,
        show: showLoadModal,
        onCancel: this.onLoadModalCancel,
        onSubmit: this.onLoadModalSubmit
      }), _react.default.createElement("div", {
        className: innerStyle
      }, _react.default.createElement(_ToolbarSection.default, null, _react.default.createElement(_ToolbarButton.default, {
        icon: "download-3-l",
        title: "Save",
        tooltip: "Save",
        onClick: this.onSaveModalOpen
      }), readOnly ? null : _react.default.createElement(_ToolbarButton.default, {
        icon: "cloud-upload-l",
        title: "Load",
        tooltip: "Load",
        onClick: this.onLoadModalOpen
      })), readOnly ? null : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ToolbarSection.default, null, _react.default.createElement(_ToolbarButton.default, {
        icon: "top-of-row-l",
        title: "Add row above",
        tooltip: "Add row above",
        onClick: this.onRowAddAbove
      }), _react.default.createElement(_ToolbarButton.default, {
        icon: "bottom-of-row-l",
        title: "Add row below",
        tooltip: "Add row below",
        onClick: this.onRowAddBelow
      }), _react.default.createElement(_ToolbarButton.default, {
        icon: "remove-row-l",
        title: "Remove row",
        tooltip: "Remove row",
        onClick: this.onRowRemove
      })), allowColumnAddRemove ? _react.default.createElement(_ToolbarSection.default, null, _react.default.createElement(_ToolbarButton.default, {
        icon: "left-of-column-l",
        title: "Add column to the left",
        tooltip: "Add column to the left",
        onClick: this.onColumnAddLeft,
        disabled: availableColumns.length === 0
      }), _react.default.createElement(_ToolbarButton.default, {
        icon: "right-of-column-l",
        title: "Add column to the right",
        tooltip: "Add column to the right",
        onClick: this.onColumnAddRight,
        disabled: availableColumns.length === 0
      }), _react.default.createElement(_ToolbarButton.default, {
        icon: "remove-column-l_1",
        title: "Remove columns",
        tooltip: "Remove columns",
        onClick: this.onColumnRemove
      }), _react.default.createElement(_reactComponents.Modal, {
        title: "Select columns to add",
        closeButton: true,
        show: this.state.showAddColumnsModal,
        onRequestHide: this.cancelAddColumnsModal,
        footer: footer
      }, _react.default.createElement(_reactComponents.Select, {
        options: availableColumns,
        value: this.state.selectedColumnsToAdd,
        onChange: this.onSelectedColumnsChanged,
        multi: true,
        clearable: true,
        tether: true
      }))) : null)));
    }
  }]);
  return Toolbar;
}(_react.PureComponent);

exports.default = Toolbar;
(0, _defineProperty2.default)(Toolbar, "propTypes", {
  additionalColumns: shapes.additionalColumns.isRequired,
  columns: _propTypes.default.arrayOf(shapes.column).isRequired,
  dispatch: _propTypes.default.func.isRequired,
  name: _propTypes.default.string.isRequired,
  optionalColumns: _propTypes.default.arrayOf(shapes.column).isRequired,
  requiredColumns: _propTypes.default.arrayOf(shapes.column).isRequired,
  rows: _propTypes.default.arrayOf(shapes.row).isRequired,
  selection: shapes.selection,
  readOnly: _propTypes.default.bool.isRequired,
  allowColumnAddRemove: _propTypes.default.bool.isRequired
});